const setSelectedStatusFormActions = {
  label: 'Vencido'
};

export default setSelectedStatusFormActions;
